// Single source of truth for mapping an operation status title to a shared
// `Badge` variant (green / red / amber / gray). Both the /operations card and
// the Ops Dashboard v2 status pill import this so the status chip looks
// identical across the two surfaces.
export type OperationStatusBadgeVariant =
  | 'active'
  | 'pending'
  | 'inactive'
  | 'error';

export const operationStatusVariant = (
  statusTitle: string | null
): OperationStatusBadgeVariant => {
  const lower = (statusTitle ?? '').toLowerCase();
  if (lower.includes('confirm')) return 'active';
  if (lower.includes('cancel') || lower.includes('reject')) return 'error';
  if (lower.includes('pending') || lower.includes('await')) return 'pending';
  return 'inactive';
};

// Whether an itinerary status reads as cancelled. Title-based (matches
// Cancelled / Cancelado / CANCELADO) — mirrors the backend detection
// (`/cancel/i`) so the card badge agrees with the History-view filter that
// surfaces these files. Used to render the "Cancelled" chip on the operations
// card.
export const isItineraryCancelled = (itineraryStatus: string | null): boolean =>
  /cancel/i.test(itineraryStatus ?? '');
